import { render, staticRenderFns } from "./CostRcj.vue?vue&type=template&id=56a40e87&scoped=true"
import script from "./CostRcj.vue?vue&type=script&lang=js"
export * from "./CostRcj.vue?vue&type=script&lang=js"
import style0 from "./CostRcj.vue?vue&type=style&index=0&id=56a40e87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a40e87",
  null
  
)

export default component.exports